import { BACKEND_URL } from "../../global";
import keycloak from "../../keycloak";

export async function renameFile(file, fileMap, name) {
    const oldFIlename = fileMap[file].name

    function getAllChildren(childArray, fileMap) {
        let newChildArray = [];
        childArray.map((each) => {
            if (fileMap[each].isDir) {
                newChildArray.push(getAllChildren(fileMap[each].childrenIds, fileMap));
            } else {
                newChildArray.push(fileMap[each]);
            }
        });
        return newChildArray.flat(Infinity);
    }

    try {
        console.log(file, fileMap, name)
        var newFileMap = { ...fileMap };
        newFileMap[file].name = name
        // Patch children path if selected file is directory
        if (fileMap[file].isDir) {
            getAllChildren(fileMap[file].childrenIds, fileMap).map(child => {
                console.log(child)
                let newPath = child.path.replace(oldFIlename, name)
                newFileMap[child.id].path = newPath
                fetch(`${BACKEND_URL}/asr_results/${child.interview_id}`, {
                    method: 'PATCH',
                    body: JSON.stringify({ path: newPath }),
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${keycloak.token}`
                    },
                })
            })
        } else {
            // patch name of selected file if not directory
            fetch(`${BACKEND_URL}/asr_results/${fileMap[file].interview_id}`, {
                method: 'PATCH',
                body: JSON.stringify({ "interview_id": name }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${keycloak.token}`
                },
            })
        }
        return newFileMap;
    } catch (error) {
        console.error("Error posting data:", error);
        return null;
    }
}

export default renameFile;